import { gql, TypedDocumentNode } from '@apollo/client'
import { companyFragment } from './CompanyFragment'
import { userPermissionFragment } from './UserPermissionFragment'
import type { UserFragment } from './__generated__/UserFragment'

export const userFragment: TypedDocumentNode<UserFragment> = gql`
  ${companyFragment}
  ${userPermissionFragment}

  fragment UserFragment on User {
    company {
      ...CompanyFragment
    }
    createdAt
    email
    firstName
    id
    lastName
    lastSeenAt
    mobile
    permissions {
      ...UserPermissionFragment
    }
    preferredLanguage
    telephone
    acceptedTermsAndConditionsAt
  }
`
